var module = angular.module('octopusApp.shared');

module.directive('interruptionField', function($compile, $templateCache) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      element: '=',
      submit: '=',
      isDisabled: '='
    },
    link: function(scope, element) {

      scope.changed = function() {
        scope.$emit("interruptionField:changed", scope.element);
      };

      scope.$watch('element', function() {
        if (!scope.element) {
          return;
        }

        var templateName = scope.element.type;
        var template = $templateCache.get('areas/shared/views/interrupt-fields/interrupt_' + templateName + '.html');
        if (!template) {
          template = $templateCache.get('areas/shared/views/interrupt-fields/interrupt_Unknown.html');
        }

        element.html('');
        element.html($compile(template)(scope));
      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/interruption_field.js
// module id = 593
// module chunks = 1